/* jshint esversion: 6 */
/* jshint ignore:start */
import './App.css';
import './Style/Style.css';
import './Style/Responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from './Component/Header';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Login from './Component/Login_Signup/Login';
import Signup from './Component/Login_Signup/Signup';
import Dashboard from './Component/pages/Dashboard';
import Details from './Component/pages/Details';
import Checkout from './Component/pages/Checkout';
import MyBooking from './Component/pages/MyBooking';
import Wallet from './Component/pages/Wallet';
import Refer from './Component/pages/Refer';
import Contact from './Component/pages/Contact';
import About from './Component/pages/About';
import PrivacyPolicy from './Component/pages/PrivacyPolicy';
import Terms from './Component/pages/Terms';
import i18n from "./Component/Language";
import Success, { Cancel } from './PaymentGetaway/PayFastRes';
import PaymentResponse from './PaymentGetaway/PaymentResponse';
import Profile from './Component/pages/Profile';
import Footer from './Component/Footer';
import Chat from './Component/pages/Chat';
import Hire from './Component/pages/Hire';

function App() {

  const location = useLocation();

  const IsShow = location.pathname.startsWith("/login") || location.pathname.startsWith("/signup") || location.pathname.startsWith("/chat");

  useEffect(() => {
    const IsChat = location.pathname.startsWith("/chat");
    if (IsChat) {
      document.body.style.background = "#f1f2f4";
    } else {
      document.body.style.background = "white";
    }
  }, [location])


  return (
    <div className='App'>
      <Header />
      <div className="content-wrapper">

        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/details' element={<Details />} />
          <Route path='/checkout' element={<Checkout />} />
          <Route path='/bookings' element={<MyBooking />} />
          <Route path='/wallet' element={<Wallet />} />
          <Route path='/refer-earn' element={<Refer />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/about' element={<About />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-condition' element={<Terms />} />
          <Route path="/done" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/PaymentRespons" element={<PaymentResponse />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/hire" element={<Hire />} />
        </Routes>

      </div>

      {!IsShow && <Footer />}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
/* jshint ignore:end */